import { VFC, ReactNode, useCallback, useEffect } from "react";
import { useClipboard, Button } from "@chakra-ui/react";
import { CopyIcon } from '@chakra-ui/icons';
import { useMessage } from "../../../hooks/useMessage";

type Props = {
  children: ReactNode;
  id: string;
  isLoading?: boolean;
  size?: string;
  value: string;
};

export const CopyButton: VFC<Props> = (props) => {
  const {
    children,
    id,
    isLoading = false,
    size = "xs",
    value,
  } = props;
  const { showMessage } = useMessage();
  const { hasCopied, onCopy } = useClipboard(value);
  
  // コピー用バッファ設定
  const doCopy = useCallback(() => {
    onCopy();
  }, [onCopy]);
  
  // コピー実行
  useEffect(() => {
    //console.log(copyBuf);
    hasCopied && showMessage({ title: "コピーしました", status: "success" });
    // eslint-disable-next-line
  }, [hasCopied]);
  
  return (
    <Button
      id={id}
      bg="orange.400"
      color="white"
      size={size}
      isDisabled={isLoading}
      isLoading={isLoading}
      _hover={{ opacity: 0.8 }}
      onClick={doCopy}
      rightIcon={<CopyIcon />}
    >
      {children}
    </Button>
  );
};
